import { DependencyList, useEffect } from 'react';
import { CallbackInterface, useRecoilCallback } from 'recoil';

type RecoilEffectCallback = (
  cbint: CallbackInterface
) => void | (() => void | undefined);

export function useRecoilEffect(
  effect: RecoilEffectCallback,
  deps: DependencyList
) {
  const callback = useRecoilCallback(cbint => effect(cbint), deps);
  useEffect(() => callback(), deps);
}
